import {SettingsApi, VersionApi} from 'hemwb-api';
import {configuration} from '../getBackendConfiguration';

const settingsApi = new SettingsApi(configuration);
export const requestSettings = () => settingsApi.getApplicationSettings();

const versionApi = new VersionApi(configuration);
export const requestVersion = () => versionApi.getVersionInfo();
